import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'subpage.sleep.hero.heading',
		defaultMessage: 'Sleep Stories, sleep meditations, music and soundscapes for your dreamiest sleep yet',
		description: 'Heading for the sleep category page hero',
	},
	body: {
		id: 'subpage.sleep.hero.body',
		defaultMessage:
			"Join millions of sound sleepers worldwide. Fall asleep easily and naturally with our Sleep Stories, sleep meditations, exclusive sleep music and sleep sounds. With hundreds of titles to choose from, you'll be drifting off to dreamland in no time. Just press play and drift away.",
		description: 'Body text for the sleep category page hero',
	},
	cta: {
		id: 'subpage.sleep.hero.cta',
		defaultMessage: 'Sleep better for free',
		description: 'Button text for the sleep category page hero',
	},
});
